import { render, staticRenderFns } from "./pcModule5.vue?vue&type=template&id=1d2ed18e&scoped=true"
import script from "./pcModule5.vue?vue&type=script&lang=js"
export * from "./pcModule5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2ed18e",
  null
  
)

export default component.exports